import Axios from "./interceptor";
import { appApiBaseUrl } from "./appApiBaseUrl";

const API_URL = appApiBaseUrl + "/api";

const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

const getCarePlan = async (data) => {
  const { userId } = data;
  const response = await Axios.get(API_URL + `/CarePlanWizardDetail/${userId}`);

  const validData = (data) => {
    if (Array.isArray(data)) {
      return data.map(validData);
    } else if (typeof data === "object" && data !== null) {
      return Object.entries(data).reduce((acc, [key, value]) => {
        if (key.toLowerCase() === "email") {
          acc[key] = isValidEmail(value) ? value : null;
        } else {
          acc[key] = validData(value);
        }
        return acc;
      }, {});
    } else {
      return data;
    }
  };

  response.data = validData(response.data);
  return response;
};

const getUsername = async (data) => {
  const response = await Axios.get(`${API_URL}/users/getUsernames`, data);
  return response;
};

const getSihAccId = async (data) => {
  const response = await Axios.get(
    `${API_URL}/carePlanWizardDetail/sihAccId`,
    data,
  );
  return response;
};

const getUsersSihAccId = async (data) => {
  const userId = data;
  const response = await Axios.get(
    `${API_URL}/carePlanWizardDetail/usersSihAccId/${userId}`,
    data,
  );
  return response;
};

const copySupportPlan = async (data) => {
  const response = await Axios.post(
    `${API_URL}/carePlanWizardDetail/copy-support-plan`,
    data,
  );
  return response;
};

export {
  getCarePlan,
  getUsername,
  getSihAccId,
  getUsersSihAccId,
  copySupportPlan,
};
